import React from "react";
import styled from "styled-components";
import "./loading.css";
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;
function LoadingScreenNew() {
  return (
    <Container>
      <div className="dot-flashing"></div>
    </Container>
  );
}

export default LoadingScreenNew;
